<template>
  <section id="about" class="section">
    <div class="container">
      <!-- Heading -->
      <p class="text-center mb-2" data-aos="fade-up" data-aos-once="true" data-aos-duration="100">
        <span class="bg-primary text-dark px-2">About Me</span>
      </p>
      <h2 class="text-10 fw-600 text-center mb-5" data-aos="fade-up" data-aos-once="true" data-aos-duration="200">
        Know Me More
      </h2>
      <!-- Heading end-->

      <div class="row">
        <div class="col-lg-8 text-center text-lg-start" data-aos="fade-up" data-aos-once="true" data-aos-delay="300">
          <h2 class="text-8 fw-400 mb-3">
            I'm
            <span class="fw-700 border-bottom border-3 border-primary">Bhavin Dabhi</span>
          </h2>
          <p class="text-5">
            I am a talented and creative UI/UX designer for mobile app design, website design, dashboard design, portal design, and more design work. I always create designs from scratch using my own creativity. I have been helping startup business.
          </p>
        </div>
        <div class="col-lg-4 mt-4 mt-lg-0 wow fadeInUp" data-wow-delay="0.2s">
          <div class="featured-box style-4">
            <div class="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
              <span class="wow heartBeat" data-wow-delay="1.3s"
                style="visibility: visible; animation-delay: 1.3s">6+</span>
            </div>
            <h3 class="text-7" data-wow-delay="2s" data-aos="zoom-out-up" data-aos-once="true" data-aos-offset="200">
              Years of <span class="fw-700">Experiance</span>
            </h3>
          </div>
        </div>
      </div>
      <dvi class="row gy-3 mt-4">
        <h2 class="text- fw-400 mb-3">
          <span class="fw-700 border-bottom border-3 border-primary">Introduction Video</span>
        </h2>
        <div class="col-lg-6">
            <video width="640"  class="vmobile_size" preload="metadata" poster="@/assets/images/youtube_thumbnail.png" controls>
             <source src="@/assets/images/video_bhavin_dabhi.mp4" type="video/mp4">
          </video>
        </div>
        <div class="col-lg-6 mt-4 ps-md-5 wow fadeInUp" data-wow-delay="0.2s">
          <div class="row">
            <div class="col-sm-6 wow fadeInUp mb-4" data-wow-delay="0.2s"
              style="visibility: visible; animation-delay: 0.2s">
              <p class="text-muted fw-500 mb-0">Happy Clients</p>
              <p class="text-4 text-dark fw-600 mb-0">100+</p>
            </div>
            <div class="col-sm-6 wow fadeInUp mb-4" data-wow-delay="0.3s"
              style="visibility: visible; animation-delay: 0.3s">
              <p class="text-muted fw-500 mb-0">Projects completed:</p>
              <p class="text-4 text-dark fw-600 mb-0">150+</p>
            </div>
            <div class="col-sm-6 wow fadeInUp mb-4" style="visibility: visible">
              <p class="text-muted fw-500 mb-0">Certificate:</p>
              <p class="text-4 text-dark fw-600 mb-0">3</p>
            </div>
            <div class="col-sm-6  wow fadeInUp mb-4" data-wow-delay="0.4s"
              style="visibility: visible; animation-delay: 0.4s">
              <p class="text-muted fw-500 mb-0">Award:</p>
              <p class="text-4 text-dark fw-600 mb-0">2</p>
            </div>
            <div class="col-sm-12  wow fadeInUp mb-4" data-wow-delay="0.4s"
              style="visibility: visible; animation-delay: 0.4s">
              <p class="text-4  fw-600">Why clients hire me:</p>
              <p class="text-4  text-muted fw-500 mb-1"> <font-awesome-icon
                  :icon="{ prefix: 'fas', iconName: 'arrow-right' }" /> Live Support with Call and chat</p>
              <p class="text-4  text-muted fw-500 mb-1"> <font-awesome-icon
                  :icon="{ prefix: 'fas', iconName: 'arrow-right' }" /> 100% Customer Stratification</p>
              <p class="text-4  text-muted fw-500 mb-1"> <font-awesome-icon
                  :icon="{ prefix: 'fas', iconName: 'arrow-right' }" /> Use Design Principles and Standards</p>
              <p class="text-4  text-muted fw-500 mb-1"> <font-awesome-icon
                  :icon="{ prefix: 'fas', iconName: 'arrow-right' }" /> Long term relationship with Customer</p>
            </div>
          </div>
        </div>
      </dvi>

      <dvi class="row gy-3 mt-4">
        <h2 class="text- fw-400 mb-3">
          <span class="fw-700 border-bottom border-3 border-primary">Happy client</span>
        </h2>
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe height="400" src="https://www.youtube.com/embed/q0U0BCLRQgw"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" style="width: 100%;" allowfullscreen></iframe>
          </div>
        </div>
      </dvi>
    </div>
  </section>
</template>

<script>
export default {
  name: "About-me",
};
</script>

<style scoped>
.ytp-cued-thumbnail-overlay-image {
  background: red !important;
}
</style>